<template>
  <div class="content-loader">
    <div class="auth-skeleton">
      <div class="auth-skeleton__rect auth-skeleton__rect--title" />
      <div class="auth-skeleton__rect auth-skeleton__rect--field1" />
      <div class="auth-skeleton__rect auth-skeleton__rect--field2" />
      <div class="auth-skeleton__rect auth-skeleton__rect--gap" />
      <div class="auth-skeleton__rect auth-skeleton__rect--line" />
      <div class="auth-skeleton__rect auth-skeleton__rect--button" />
      <div class="auth-skeleton__rect auth-skeleton__rect--footer" />
      <div class="auth-skeleton__rect auth-skeleton__rect--footer-wide" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.auth-skeleton {
  position: relative;
  width: 100%;
  aspect-ratio: 360 / 560;
}

.auth-skeleton__rect {
  position: absolute;
  left: 0;
  right: 0;
  border-radius: 3px;
  background: linear-gradient(90deg, #f3f3f3 0%, #ecebeb 50%, #f3f3f3 100%);
  background-size: 200% 100%;
  animation: shimmer 1s linear infinite;

  &--title {
    top: 0;
    left: 13.9%;
    right: 13.9%;
    height: 6.429%;
  }

  &--field1 {
    top: 12.5%;
    height: 8.571%;
  }

  &--field2 {
    top: 25%;
    height: 8.571%;
  }

  &--gap {
    top: 46.429%;
    height: 10.714%;
  }

  &--line {
    top: 64.286%;
    height: 3.214%;
  }

  &--button {
    top: 73.214%;
    height: 10.714%;
  }

  &--footer {
    top: 89.286%;
    left: 27.8%;
    right: 27.8%;
    height: 3.214%;
  }

  &--footer-wide {
    top: 96.429%;
    left: 13.9%;
    right: 13.9%;
    height: 3.214%;
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
